import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListES = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaES.socialmediaListES);
    const [socialmediaListES, setSocialmedialListES] = useState(s);
    const loading = useSelector(state => state.socialmediaES.loading);
    const e = useSelector(state => state.socialmediaES.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaES.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.SPANISH_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListES}
            setSocialmedialList={setSocialmedialListES}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}